import Grid from '@material-ui/core/Grid';
import AnalysisDescriptorsTable from 'pages/Evaluation/Product/ScenariosManagement/AnalysisDescriptorsTable'
import Descriptors from 'pages/Evaluation/Product/ScenariosManagement/DescriptorsTable'
import React from 'react';
import { SU } from 'utils/constants/descriptorTypes';
import { TABLE_HEIGHT_SPLIT_2VIEW } from 'utils/ui/constants';

const TABLE_HEIGHT = TABLE_HEIGHT_SPLIT_2VIEW(0);

const Component = props => {
  const { augmentedDescriptors, lcs, scenario, productId } = props;

  return (
    <Grid container>
      <Grid item xs={7}>
        <Descriptors
          descriptorFilter={SU}
          scenario={scenario}
          productId={productId}
          lcs={lcs}
          TABLE_HEIGHT={TABLE_HEIGHT}
        />
      </Grid>
      <Grid item xs={5}>
        <AnalysisDescriptorsTable
          augmentedDescriptors={augmentedDescriptors}
          TABLE_HEIGHT={TABLE_HEIGHT}
        />
      </Grid>
    </Grid>
  )
};

export default Component;
